import { render, staticRenderFns } from "./relevance-form-modal2.vue?vue&type=template&id=030a8b2e&scoped=true&"
import script from "./relevance-form-modal2.vue?vue&type=script&lang=ts&"
export * from "./relevance-form-modal2.vue?vue&type=script&lang=ts&"
import style0 from "./relevance-form-modal2.vue?vue&type=style&index=0&id=030a8b2e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030a8b2e",
  null
  
)

export default component.exports